import { useState } from "react";
import { useImportPackages } from '@core/api/useImport';
import { toast } from "sonner";
import { EnhancedImportFile } from '@shared/components/EnhancedImportFile';
import ImportedPackages from "../components/ImportedPackages";
import ImportStatistics from "../components/ImportStatistics";
import { useTranslation } from "react-i18next";
import HeadLayout from "@shared/layouts/HeadLayout";

const ImportPackages = () => {
  const { t } = useTranslation();
  const { data, isPending, mutate: importFile } = useImportPackages();

  const [file, setFile] = useState(null);
  const template = {
    name: "import-packages.xlsx",
    url: "/files/import-packages.xlsx",
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      return null;
    }
    const toastId = toast.loading(t("toast.uploading"));

    const formData = new FormData();
    formData.append("file", file);
    importFile(formData, {
      onSuccess: () => {
        console.log("Success");
        toast.success(`Packages created`, {
          id: toastId,
        });
      },
      onError: (error) => {
        toast.error(error.response.data.message, {
          id: toastId,
        });
      },
    });
  };

  return (
    <>
      <HeadLayout title={t("packages.importPackages")} />
      <div className="flex flex-col space-y-4">
        <div className="w-full">
          <EnhancedImportFile
            template={template}
            handleFileChange={handleFileChange}
            handleUpload={handleUpload}
            isPending={isPending}
          />
        </div>
        {data && JSON.stringify(data) !== "{}" && (
          <ImportStatistics stats={data.summary} />
        )}

        <ImportedPackages />
      </div>
    </>
  );
};

export default ImportPackages;
